import React from 'react';
import { getStudentData } from '../../assets/data';

// Extracted from StudentProfile.js (Phase 3 of the platform-health plan:
// split the file mechanically, without changing behavior).
export default function CopyLessonModal({
  show,
  lessonToCopy,
  copyTargetStudent,
  onTargetStudentChange,
  copyDate,
  onDateChange,
  copyModalStudents,
  submitting,
  onClose,
  onConfirm,
}) {
  if (!show) return null;

  const local = getStudentData();
  const merged = { ...local, ...(copyModalStudents || {}) };

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal copy-lesson-modal">
        <div className="custom-modal-header">
          <h3>Copy Lesson</h3>
          <button className="custom-modal-close" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
        <div className="custom-modal-body">
          <p>Copy lesson "{lessonToCopy?.title}" to another student:</p>

          <div className="copy-form-group copy-form-group-select">
            <label>Student</label>
            <select
              value={copyTargetStudent}
              onChange={(e) => onTargetStudentChange(e.target.value)}
              className="copy-select"
            >
              <option value="">Select a student...</option>
              {Object.keys(merged).map(slug => (
                <option key={slug} value={slug}>
                  {merged[slug]?.name || slug}
                </option>
              ))}
            </select>
          </div>

          <div className="copy-form-group copy-form-group-date">
            <label>Date</label>
            <input
              type="date"
              value={copyDate}
              onChange={(e) => onDateChange(e.target.value)}
              className="copy-input copy-input-date"
            />
          </div>
        </div>
        <div className="custom-modal-footer">
          <button className="custom-modal-btn cancel-btn" onClick={onClose} disabled={submitting}>
            Cancel
          </button>
          <button className="custom-modal-btn confirm-btn" onClick={onConfirm} disabled={submitting}>
            {submitting ? (
              <>
                <span className="copy-lesson-btn-spinner" aria-hidden />
                Copying…
              </>
            ) : (
              'Copy Lesson'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
